import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { PartnerMutator } from '@/lib/entity/partner'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type PartnerSchema = PartnerMutator['merged']

export const PartnerConverter: Converter<PartnerSchema> = {
  icon: () => i18next.t('stages.icon.partner'),
  title: () => i18next.t('stages.table.partner'),
  subTitle: async (merged) => merged.name ?? i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.partner.${column}`)
    return match(column)
      .with('name', (column) => asModifiedField(label, modified[column]!))
      .with('id', 'order', () => undefined)
      .exhaustive()
  }
}
